export default "__VITE_ASSET__f3d65e09__"